/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Confirm_ApproveInputs */

const en_admin_registration_confirm_approve = /** @type {(inputs: Admin_Registration_Confirm_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve this registration? The company and user account will be created automatically.`)
};

const de_admin_registration_confirm_approve = /** @type {(inputs: Admin_Registration_Confirm_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung wirklich genehmigen? Das Unternehmen und der Benutzer-Account werden automatisch erstellt.`)
};

/**
* | output |
* | --- |
* | "Approve this registration? The company and user account will be created automatically." |
*
* @param {Admin_Registration_Confirm_ApproveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_confirm_approve = /** @type {((inputs?: Admin_Registration_Confirm_ApproveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Confirm_ApproveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_confirm_approve(inputs)
	return en_admin_registration_confirm_approve(inputs)
});